export default {
  create_title: 'Añadir endpoint de webhook',
  edit_title: 'Editar endpoint de webhook',
  form: {
    url: 'URL del endpoint HTTPS',
    description: 'Descripción',
    description_placeholder: 'p. ej. Eventos de pedidos para el POS',
    events: 'Eventos a entregar',
    events_required: 'Selecciona al menos un evento.',
    events_hint: 'Solo los eventos seleccionados se envían a este endpoint.',
    events_selected: '{{selected}} de {{total}}',
    event_groups: {
      order: 'Pedidos',
      store: 'Tienda',
      product: 'Productos',
      modifier: 'Modificadores',
      menu_push: 'Envíos de menú',
      payout: 'Pagos',
    },
    status: 'Estado',
    status_active: 'Activo',
    status_disabled: 'Deshabilitado',
    status_auto_disabled: 'Deshabilitado automáticamente (elige Activo para reactivarlo)',
  },
  buttons: {
    cancel: 'Cancelar',
    create: 'Crear',
    save: 'Guardar',
  },
  toasts: {
    created: 'Endpoint creado.',
    updated: 'Endpoint actualizado.',
    error: 'No se pudo guardar el endpoint. Inténtalo de nuevo.',
  },
};
